import {DateTime} from 'luxon';
import {createSelector} from 'reselect';

import {getNamespaceFromParameters} from '../../../../analytics/helpers/analyticsUrlHelpers';
import {createShallowEqualSelector} from '../../../../helpers/reselectHelpers';
import {getUserTeams} from '../../../data/teams/teamsSelectors';
import {getAnalyticsPanel} from '../analyticsPanelSelectors';

export const getAnalyticsParameters = createSelector(getAnalyticsPanel, ({parameters}) => parameters);

export const getAnalyticsSelectedNamespace = createSelector(getAnalyticsParameters, (parameters) =>
  getNamespaceFromParameters(parameters),
);

export const getAnalyticsSelectedNamespaceTeam = createSelector(
  [getUserTeams, getAnalyticsSelectedNamespace],
  (userTeams, selectedNamespace) => userTeams.find((team) => team.namespace === selectedNamespace),
);

export const getAnalyticsSelectedNamespaceTeamPreferences = createSelector(
  getAnalyticsSelectedNamespaceTeam,
  (selectedTeam) => {
    if (!selectedTeam) {
      return undefined;
    }
    return selectedTeam.preferences;
  },
);

export const getAnalyticsSelectedNamespaceTeamBusinessHours = createSelector(
  getAnalyticsSelectedNamespaceTeamPreferences,
  (preferences) => {
    if (!preferences) {
      return undefined;
    }
    return preferences.businessHours;
  },
);

export const getAnalyticsReportType = createSelector(
  getAnalyticsPanel,
  ({parameters}) => parameters.reportType,
);

const getAnalyticsTimes = createSelector(getAnalyticsParameters, ({query}) => [query.from, query.to]);

// Shallow-compare the output of getAnalyticsTimes to stabilize the DateTimes.
export const getAnalyticsDatetimes = createShallowEqualSelector(getAnalyticsTimes, ([from, to]) => {
  const startDatetime = from ? DateTime.fromMillis(from) : undefined;
  const endDatetime = to ? DateTime.fromMillis(to) : undefined;

  return [startDatetime, endDatetime];
});

export const getAnalyticsPreviousPeriodDatetimes = createSelector(
  getAnalyticsDatetimes,
  ([startDate, endDate]) => {
    if (!startDate || !endDate) {
      return [undefined, undefined];
    }

    const previousPeriodStart = startDate.minus(endDate.diff(startDate));
    return [previousPeriodStart, startDate.minus({day: 1})]; // Removing one day to end date so "previous / current" can look "1-7 / 8-14"
  },
);

export const getAnalyticsSelectedViewId = createSelector(
  getAnalyticsParameters,
  (parameters) => parameters.query.selectedViewId,
);
